export default {
  logs: [],
  filters: {},
  sort: {
    by: 'eventTime',
    order: 'desc',
  },
  currentPage: 1,
  totalPages: 0,
  totalItems: 0,
  limit: 25,
}
